import { getLocationPath } from "./getLocationPath";

export const getAhuBaseUrl = (pathname, config) => {
    const isLocalEnvironment = config.ahu_application.includes("localhost");
    return isLocalEnvironment
        ? config.ahu_application
        : `${config.sds_url.replace(/\/+$/, "")}${getLocationPath(pathname)}/`;
};

export default getAhuBaseUrl;
